import packageJson from '../package.json'

export const STAGING_HOSTS = [
  "demo.fundamentalportal.com",
  "stg.fundflow.slatestudio.com",
]

export const PRODUCTION_DOMAINS = [
  "vortexinvest.co",
  "fundamentalportal.com",
  "prd.fundflow.slatestudio.com",
]

export const CONFIG = {
  dev: {
    hasFooter: true,
    hasDocusign: true,
    hasCampaigns: true,
    is2FaRequired: true,
    isAchOptionEnabled: true,
    isAccreditationFlowEnabled: true,
    consoleOrganizationId: "OOK",
    isCustomDwollaTemplatesEnabled: true,
    ENVIRONMENT_TAG: "dev",
    ENVIRONMENT_LABEL: "dev",
    PLATFORM_DOMAIN: "fundflow.slatestudio.com",
    IMGIX_DOMAIN: "fundflow-storage-public-dev.imgix.net",
    S3_BUCKET_URL: "https://fundflow-storage-public-dev.s3.us-east-1.amazonaws.com/",
    CUSTOMER_EMAIL_DOMAIN: "inbound-dev.fundflow.slatestudio.com",
    AUTHENTICATOR_CONFIG: {
      storage: window.localStorage,
      aws_user_pools_id: "us-east-1_7OILtrdZi",
      aws_cognito_region: "us-east-1",
      aws_user_pools_web_client_id: "7k983mectopgjqu64ttlrpgd0p",
    },
    SENTRY_ENVIRONMENT: "development",
    SENTRY_INVESTOR_DNS: "https://da02bc444170f0c91fbc590f64c23696@o4505997396475904.ingest.sentry.io/4506314410688512",
    SENTRY_BACKSTAGE_DNS: "https://b4c70c2e82787e9362cadbd41c5a69ac@o4505997396475904.ingest.sentry.io/4506314409377792",
    PLATFORM_NAME: "Fundflow Portal",
    PLATFORM_EMAIL: "support@fundflow.slatestudio.com",
    PLATFORM_WEBSITE: "fundflow.slatestudio.com",
    PLATFORM_SHORT_NAME: "Fundflow",
    PLATFORM_VERSION: packageJson.version,
    IMPERSONATION_ENABLED_ORG_IDS: ["O499"],
    IMMUTABLE_BENEFICIARY_NAME: 'Rise48 AM LLC',
    RESTRICT_TRANSFER_INVESTMENTS_FEATURE_TO_EMAILS: [],
    RESTRICT_TRANSFER_INVESTMENTS_SUBMIT_TO_EMAILS: [],
    SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS: [],
    EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS: ["ORQG", "O99D"],
    RUM_REGION: "us-east-1",
    RUM_APP_ID: "325dc1d9-0c91-4c75-9006-304382c1ecb6",
    RUM_IDENTITY_POOL_ID: "us-east-1:584f565c-009f-4c58-a34a-9484a369a942",
  },
  stg: {
    hasFooter: true,
    hasDocusign: false,
    hasCampaigns: true,
    is2FaRequired: true,
    isAchOptionEnabled: true,
    consoleOrganizationId: "O49",
    isAccreditationFlowEnabled: false,
    isCustomDwollaTemplatesEnabled: true,
    ENVIRONMENT_TAG: "stg",
    ENVIRONMENT_LABEL: "demo",
    PLATFORM_DOMAIN: "fundamentalportal.com",
    IMGIX_DOMAIN: "fundflow-storage-public-dev.imgix.net",
    S3_BUCKET_URL: "https://fundflow-storage-public-dev.s3.us-east-1.amazonaws.com/",
    CUSTOMER_EMAIL_DOMAIN: "inbound-stg.fundflow.slatestudio.com",
    AUTHENTICATOR_CONFIG: {
      storage: window.localStorage,
      aws_user_pools_id: "us-east-1_HvVHICzPe",
      aws_cognito_region: "us-east-1",
      aws_user_pools_web_client_id: "7pe65rvnihdddvp5mjeeoqhge5",
    },
    SENTRY_ENVIRONMENT: "staging",
    SENTRY_INVESTOR_DNS: "https://da02bc444170f0c91fbc590f64c23696@o4505997396475904.ingest.sentry.io/4506314410688512",
    SENTRY_BACKSTAGE_DNS: "https://b4c70c2e82787e9362cadbd41c5a69ac@o4505997396475904.ingest.sentry.io/4506314409377792",
    PLATFORM_NAME: "Fundamental Portal",
    PLATFORM_EMAIL: "support@fundamentalportal.com",
    PLATFORM_WEBSITE: "fundamentalportal.com",
    PLATFORM_SHORT_NAME: "Fundamental",
    PLATFORM_VERSION: packageJson.version,
    IMPERSONATION_ENABLED_ORG_IDS: ["O6E"],
    IMMUTABLE_BENEFICIARY_NAME: 'Rise48 AM LLC',
    RESTRICT_TRANSFER_INVESTMENTS_FEATURE_TO_EMAILS: [],
    RESTRICT_TRANSFER_INVESTMENTS_SUBMIT_TO_EMAILS: [],
    SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS: [],
    EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS: [],
    RUM_REGION: "us-east-1",
    RUM_APP_ID: "0ebd6873-b805-44bb-b2fb-0c31eeaba1aa",
    RUM_IDENTITY_POOL_ID: "us-east-1:09b9057b-1283-4f8f-848e-30501aeb5754",
  },
  prd: {
    hasFooter: true,
    hasDocusign: true,
    hasCampaigns: false,
    is2FaRequired: true,
    isAchOptionEnabled: false,
    consoleOrganizationId: "O49",
    isAccreditationFlowEnabled: false,
    isCustomDwollaTemplatesEnabled: true,
    ENVIRONMENT_TAG: "prd",
    ENVIRONMENT_LABEL: "",
    PLATFORM_DOMAIN: "fundamentalportal.com",
    IMGIX_DOMAIN: "fundflow-storage-public-prd.imgix.net",
    S3_BUCKET_URL: "https://fundflow-storage-public-prd.s3.us-east-1.amazonaws.com/",
    CUSTOMER_EMAIL_DOMAIN: "inbound-prd.fundflow.slatestudio.com",
    AUTHENTICATOR_CONFIG: {
      storage: window.localStorage,
      aws_user_pools_id: "us-east-1_rwXtMOaQp",
      aws_cognito_region: "us-east-1",
      aws_user_pools_web_client_id: "2268dok4kkushvg65gcrfv9blu",
    },
    SENTRY_ENVIRONMENT: "production",
    SENTRY_INVESTOR_DNS: "https://da02bc444170f0c91fbc590f64c23696@o4505997396475904.ingest.sentry.io/4506314410688512",
    SENTRY_BACKSTAGE_DNS: "https://b4c70c2e82787e9362cadbd41c5a69ac@o4505997396475904.ingest.sentry.io/4506314409377792",
    PLATFORM_NAME: "Fundamental Portal",
    PLATFORM_EMAIL: "support@fundamentalportal.com",
    PLATFORM_WEBSITE: "fundamentalportal.com",
    PLATFORM_SHORT_NAME: "Fundamental",
    PLATFORM_VERSION: packageJson.version,
    IMPERSONATION_ENABLED_ORG_IDS: ["ONM", "O8E", "OP4L", "O6E"],
    IMMUTABLE_BENEFICIARY_NAME: 'Rise48 AM LLC',
    RESTRICT_TRANSFER_INVESTMENTS_FEATURE_TO_EMAILS: [
      "alex@slatestudio.com",
      "jerry@rise48equity.com",
      'kbouet@rise48equity.com',
      "dmitryo@slatestudio.com",
      "edelk@rise48equity.com",
      "mkjellsen@rise48equity.com",
      "dgeissler@rise48equity.com",
      "rswier@rise48equity.com",
      "investors@rise48equity.com",
    ],
    RESTRICT_TRANSFER_INVESTMENTS_SUBMIT_TO_EMAILS: [
      "jerry@rise48equity.com",
      'kbouet@rise48equity.com',
      "edelk@rise48equity.com",
      "dgeissler@rise48equity.com",
    ],
    SCHEDULE_DISTRIBUTIONS_ENABLED_ORG_IDS: [],
    EXTERNAL_INVESTOR_PORTAL_ENABLED_ORG_IDS: [],
    RUM_REGION: "us-east-1",
    RUM_APP_ID: "0ebd6873-b805-44bb-b2fb-0c31eeaba1aa",
    RUM_IDENTITY_POOL_ID: "us-east-1:09b9057b-1283-4f8f-848e-30501aeb5754",
  }
}
